import React from "react";
import PieceFilterList from "./pieceFilterList";
import { CountryAmountDTO, PieceFilterDTOComposerCountriesEnum } from "../../openapi-generated-client";
import { PieceFilterAmountListElementData } from "./pieceFilterAmountListElement";
import { formatEnumValue } from "../../utils/objectUtils";

interface PieceFilterCountryListProps {
    countries: Array<CountryAmountDTO>;
    countriesChosen: PieceFilterDTOComposerCountriesEnum[];
    setCountriesChosen: (v: PieceFilterDTOComposerCountriesEnum[]) => void;
    maxElements: number;
}

export default function PieceFilterCountryList(props: PieceFilterCountryListProps) {

    var countriesAvailable: PieceFilterAmountListElementData[] = [];
    var countriesChosen: PieceFilterAmountListElementData[] = [];

    for(var country of props.countries) {
        if(!country) continue;
        if(props.countriesChosen.find(c => c === country.country)) {
            continue;
        }
        countriesAvailable.push(new PieceFilterAmountListElementData(country.country ? formatEnumValue(country.country) : "Unknown", country.amount ? country.amount : 0));
    }

    for(var chosenCountry of props.countriesChosen) {
        countriesChosen.push(new PieceFilterAmountListElementData(formatEnumValue(chosenCountry), 1));
        countriesAvailable.splice(countriesChosen.length-1, 0, new PieceFilterAmountListElementData(formatEnumValue(chosenCountry), props.countries.find(c => c.country === chosenCountry)?.amount ?? 0));
    }

    return <PieceFilterList maxElements={props.maxElements} options={countriesAvailable} active={countriesChosen} onUpdate={(v: PieceFilterAmountListElementData[]) => {
            const newCountriesChosen: PieceFilterDTOComposerCountriesEnum[] = [];
            for(var country of v) {
                var countryEnum = Object.values(PieceFilterDTOComposerCountriesEnum).find(c => formatEnumValue(c) === country.name);
                if(countryEnum) {
                    newCountriesChosen.push(countryEnum);
                }else {
                    console.log("Country enum not found for country name " + country.name);
                }
            }
            props.setCountriesChosen(newCountriesChosen);
        }}/>;
    
} 